var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonLightsail32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Amazon-Lightsail_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Amazon-Lightsail_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/Compute",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.1698113,21.5 L18.2075472,21.5 L18.2075472,20.5 L16.1698113,20.5 L16.1698113,21.5 Z M13.1132075,21.5 L15.1509434,21.5 L15.1509434,20.5 L13.1132075,20.5 L13.1132075,21.5 Z M10.0566038,21.5 L12.0943396,21.5 L12.0943396,20.5 L10.0566038,20.5 L10.0566038,21.5 Z M7,21.5 L9.03773585,21.5 L9.03773585,20.5 L7,20.5 L7,21.5 Z M30.1782264,24.142 L31.161434,23.82 L30.1782264,23.499 L29.8511698,22.534 L29.5230943,23.499 L28.5409057,23.82 L29.5230943,24.142 L29.8511698,25.106 L30.1782264,24.142 Z M18.6670566,25.826 L18.3389811,26.791 L17.3557736,27.113 L18.3389811,27.435 L18.6670566,28.399 L18.9941132,27.435 L19.9773208,27.113 L18.9941132,26.791 L18.6670566,25.826 Z M18.6670566,13.386 L18.3389811,14.351 L17.3557736,14.673 L18.3389811,14.994 L18.6670566,15.959 L18.9941132,14.994 L19.9773208,14.673 L18.9941132,14.351 L18.6670566,13.386 Z M20.5438113,21.002 C22.413434,22.205 23.7277736,24.551 24.2698113,27.662 C25.3121132,26.321 26.9728679,23.753 26.9728679,21.002 C26.9728679,18.264 25.5046792,15.858 24.2728679,14.322 C23.7349057,17.442 22.4185283,19.796 20.5438113,21.002 L20.5438113,21.002 Z M19.2722642,21.461 C19.0847925,21.383 18.9635472,21.202 18.9635472,21.002 C18.9635472,20.802 19.0847925,20.621 19.2722642,20.542 C21.4984906,19.605 23.0104906,16.888 23.4170189,13.088 C23.4384151,12.892 23.5749434,12.726 23.7654717,12.665 C23.956,12.603 24.1669057,12.658 24.3013962,12.805 C25.6799245,14.301 27.9917358,17.355 27.9917358,21.002 C27.9917358,24.875 25.167434,28.251 24.3013962,29.194 C24.2046038,29.302 24.0660377,29.36 23.9233962,29.36 C23.871434,29.36 23.8184528,29.352 23.7664906,29.335 C23.5759623,29.274 23.4384151,29.109 23.4170189,28.913 C23.007434,25.114 21.4974717,22.398 19.2722642,21.461 L19.2722642,21.461 Z M34,20.5 C34,26.841 28.7436604,32 22.2830189,32 C17.0623396,32 12.4254717,28.561 11.0072075,23.636 L11.9883774,23.364 C13.2833585,27.86 17.5167547,31 22.2830189,31 C28.1822642,31 32.9811321,26.29 32.9811321,20.5 C32.9811321,14.71 28.1822642,10 22.2830189,10 C17.1183774,10 12.693434,13.613 11.7621887,18.59 L10.7586038,18.41 C11.7795094,12.958 16.6262642,9 22.2830189,9 C28.7436604,9 34,14.159 34,20.5 L34,20.5 Z",
    id: "Amazon-Lightsail-Icon_32_Squid",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonLightsail32);
export default __webpack_public_path__ + "static/media/Arch_Amazon-Lightsail_32.010162a7b2e8fce1f2086dc72277a6b7.svg";
export { ForwardRef as ReactComponent };